import styled from 'styled-components';

export const MainArea = styled.div`
  float: left;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  flex: 1;

  @media (max-width: 1024px) {
    padding: 0;
  }
`;

export const Header = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex-direction: row;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.LIGHT1}`};
  padding: 20px 15px;
  align-items: center;

  i {
    margin-right: 10px;
  }

  div {
    flex-direction: column;
    display: flex;
    float: left;
    flex: 1;
  }

  h1 {
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: -15px;
  }

  h2 {
    color: ${({ theme }) => theme.colors.TEXT4};
    font-size: 12px;
  }

  small {
    background: rgb(19, 226, 123);
    font-weight: 700;
    color: ${({ theme }) => theme.colors.TEXT1};
    align-self: flex-start;
    font-size: 8px;
    position: relative;
    margin: -46px 0px 0px 100px;
    padding: 4px;
    border-radius: 8px;
    text-transform: uppercase;
    text-decoration: none;
  }

  button {
    background: none;
    margin-left: 10px;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.5;
    }
  }

  @media (max-width: 1024px) {
    padding: 25px 15px 15px 15px;
  }
`;

export const MainAreaContent = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  overflow-y: scroll;
  padding: 20px 0 0 10px;

  @media (max-width: 1024px) {
    padding: 10px;
  }
`;

export const Footer = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-top: ${({ theme }) => `2px solid ${theme.colors.BORDER}`};

  @media (max-width: 1024px) {
    padding: 15px;
  }
`;

export const InputArea = styled.div`
  float: left;
  width: 100%;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.LIGHT1};
  display: flex;
  flex-direction: row;
  margin: 20px 0 0 0;
  padding: 0 15px 0 0;

  input {
    width: 100%;
    float: left;
    height: 50px;
    background: none;
    border: none;
    padding: 0 20px;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.TEXT1};
    font-weight: 700;
  }

  button {
    background: none;
    padding: 0;
    margin: 0 0 0 12px;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.5;
    }
  }

  @media (max-width: 1024px) {
    input {
      height: 40px;
      font-size: 12px;
    }
  }
`;

export const Question = styled.div`
  float: right;
  max-width: 98%;
  background: ${({ theme }) => theme.colors.LIGHT1};
  padding: 15px;
  color: ${({ theme }) => theme.colors.TEXT1};
  font-size: 12px;
  border-radius: 0 10px 10px 10px;
  margin: 0 0 20px 0px;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;

  small {
    font-size: 10px;
    font-weight: normal;
    margin: 5px 0 0 0;
    color: ${({ theme }) => theme.colors.TEXT4};
  }

  @media (max-width: 1024px) {
    font-size: 10px;

    small {
      font-size: 8px;
    }
  }
`;

export const Message = styled.div`
  float: left;
  max-width: 96%;
  background: ${({ theme }) => theme.colors.LIGHT1};
  padding: 20px;
  color: ${({ theme }) => theme.colors.TEXT1};
  font-size: 12px;
  border-radius: 10px 10px 0px 10px;
  margin: 0 0 20px 0;
  display: flex;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  flex-direction: column;

  &.prompt {
    background: rgba(75, 64, 218, 0.5);
  }

  > div {
    width: 100%;
    float: left;

    table,
    td {
      background: ${({ theme }) => theme.colors.LIGHT1};
    }

    table {
      border-collapse: collapse;
      width: 100%;
      margin: 15px 0;
      overflow-x: scroll;
    }
    th,
    td {
      border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
      padding: 12px;
      text-align: left;
    }

    th {
      background: ${({ theme }) => theme.colors.LIGHT1};
      color: ${({ theme }) => theme.colors.TEXT1};
    }

    tr:nth-child(even) {
      background: ${({ theme }) => theme.colors.LIGHT1};
    }

    strong,
    b {
      color: ${({ theme }) => theme.colors.ORANGE};
    }

    p {
      line-height: 1.6;
    }

    ul {
      margin: 10px 0;
      padding-left: 20px;
    }

    li {
      margin: 5px 0;
    }

    a {
      color: ${({ theme }) => theme.colors.TEXT3};
      cursor: pointer;
      text-decoration: underline;
    }

    small {
      opacity: 0.8;
      font-size: 12px;
      line-height: 18px;
    }

    a:hover {
      color: ${({ theme }) => theme.colors.ORANGE};
    }
  }

  > small {
    font-size: 10px;
    font-weight: normal;
    margin: 5px 0 0 0;
    color: ${({ theme }) => theme.colors.TEXT4};
  }

  button {
    background: none;
    display: flex;
    width: 50px;
    height: 50px;
    align-self: flex-end;
    margin-top: -70px;
    margin-bottom: 20px;
    float: right;
    background: ${({ theme }) => theme.colors.BTNBG};
    cursor: pointer;
    outline: none;
    border-radius: 100%;
    transition: all 0.5s ease;

    &:hover {
      background: ${({ theme }) => theme.colors.BTNBGH};
    }
  }

  @media (max-width: 1024px) {
    font-size: 10px;

    small {
      font-size: 8px;
    }
  }
`;

export const ToBottom = styled.button.attrs({
  type: 'button',
})`
  position: fixed;
  z-index: 3000;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.LIGHT2};
  border-radius: 100%;
  right: 20px;
  bottom: 120px;

  &:hover {
    background: ${({ theme }) => theme.colors.LIGHT2};
    opacity: 0.5;
  }

  @media (max-width: 1024px) {
    right: 20px;
    bottom: 160px;
  }
`;
